module.exports = __webpack_public_path__ + "img/ysf.5b0108de.jpg";